<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <v-layout wrap>
          <v-flex xs6 style="padding: 10px">
            <v-layout wrap>
              <v-flex xs6 style="padding-right: 10px">
                <i-datepicker
                    value=""
                    label="Từ ngày"
                    clearable
                    @clearText="clearFromDate"
                    @change="onChangeFromDate"
                />
              </v-flex>
              <v-flex xs6>
                <i-datepicker
                    value=""
                    label="Đến ngày"
                    clearable
                    @clearText="clearToDate"
                    @change="onChangeToDate"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <c-search-form
            :rows-per-page-items="1000"
            :page-size="1000"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="id"
            search-url="/getAccountPartPoint/searchAllV8?sortField=status,id&"
            create-url="/getAccountPartPoint/save"
            delete-url="/getAccountPartPoint/delete"
            form-type="intable"
            custom-create-new
            custom-edit-item
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :acceptView="true"
            :accept-edit="false"
            :accept-create="false"
            :acceptExport="6"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/topic/TopicCreate";
import {statusMHBL} from "@/constants/areaConstants";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Báo cáo L1 Ver 2 Tổng",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      programName: null,
      programId: null,
      ageId: null,
      ageName: null,
      levelNumber: null,
      levelId: null,
      fromDate: null,
      toDate: null,
      weekTotal: null,
      hiddenFields: {
        typeId: "0",
        fromDate: null,
        toDate: null,
      },
      fields: [
        {
          value: 'dateStr',
          text: 'Date',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countAllUserRegister',
          text: 'AllUser(L0)',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countAllUserRegisterFollowPhone',
          text: 'AllUserFlPhone',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countClickStudy',
          text: 'ClickP1',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentClickStudy',
          text: 'ClickP1/AllUser',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countFinishStudy',
          text: 'FinishP1',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentFinishStudy',
          text: 'FinishP1/ClickP1',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentFinishF1All',
          text: 'FinishP1/L0',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countClickListen',
          text: 'ClickP2',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countFinishListen',
          text: 'FinishP2',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentFinishListen',
          text: 'FinishP2/ClickP2',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentFinishF2All',
          text: 'FinishP2/L0',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countClickPractise',
          text: 'ClickP3',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countFinishPractise',
          text: 'FinishP3',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentFinishPractise',
          text: 'FinishP3/ClickP3',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentFinishF3All',
          text: 'FinishP3/L0',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countClickWriting',
          text: 'ClickP4',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'countFinishWriting',
          text: 'FinishP4',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentFinishWriting',
          text: 'FinishP4/ClickP4',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
        {
          value: 'percentFinishF4All',
          text: 'FinishP4/L0',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 5%;",
        },
      ],
    };
  },

  created() {
  },


  methods: {

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },

    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    clearFromDate() {
      this.hiddenFields.fromDate = new Date();
    },
    clearToDate() {
      this.hiddenFields.toDate = new Date();
    },

    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/tracking/view/' + item.userName,
        query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
